/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

export default {
    process: {
        title: '',
        speedName: '发车单号',
        orderNo: '',
        step: [
            {
                id: '1',
                images: {
                    active: require('@/assets/carActive.png'),
                    notActive: require('@/assets/carNotActive.png')
                },
                carName: '',
                carTimes: ''
            },
            {
                id: '1',
                images: {
                    active: require('@/assets/carActive.png'),
                    notActive: require('@/assets/carNotActive.png')
                },
                carName: '',
                carTimes: ''
            },
            {
                id: '1',
                images: {
                    active: require('@/assets/carActive.png'),
                    notActive: require('@/assets/carNotActive.png')
                },
                carName: '',
                carTimes: ''
            },
            {
                id: '',
                images: {
                    active: require('@/assets/carActive.png'),
                    notActive: require('@/assets/carNotActive.png')
                },
                carName: '',
                carTimes: ''
            },
            {
                id: '',
                images: {
                    active: require('@/assets/carActive.png'),
                    notActive: require('@/assets/carNotActive.png')
                },
                carName: '',
                carTimes: ''
            },
            {
                id: '',
                images: {
                    active: require('@/assets/carActive.png'),
                    notActive: require('@/assets/carNotActive.png')
                },
                carName: '',
                carTimes: ''
            }
        ]
    },
    infoData: [
        {
            title: '基本信息',
            splitLine: true,
            subItems: [
                {
                    label: '车牌',
                    value: '',
                    images: {
                        value: '定位',
                        url: require('@/assets/position.png')
                    }
                },
                {
                    label: '司机',
                    value: ''
                },
                {
                    label: '承运商',
                    value: ''
                }
            ]
        },
        {
            subItems: [
                {
                    label: '平台',
                    value: ''
                },
                {
                    label: '是否顺路带回',
                    value: ''
                },
                {
                    label: '备注',
                    value: ''
                }
            ]
        }
    ],
    feeInfoData: [
        {
            subItems: [
                {
                    label: '运输成本',
                    value: '',
                    minWidth: '200px'
                },
                {
                    label: '预付金额',
                    value: '',
                    minWidth: '200px'
                },
                {
                    label: '预付方式',
                    value: '',
                    minWidth: '200px'
                },
                {
                    label: '信息费用',
                    value: '',
                    minWidth: '200px'
                },
                {
                    label: '税率',
                    value: '',
                    minWidth: '200px'
                },
                {
                    label: '油卡金额',
                    value: '',
                    minWidth: '200px'
                }
            ]
        }
    ],
    tableDataItems: [
        {
            prop: 'senderDetailAddr',
            label: '站点名称',
            type: 'normal'
        },
        {
            prop: 'senderDetailAddrAll',
            label: '站点地址',
            type: 'normal'
        },
        {
            prop: 'networkAffect',
            label: '站点作用',
            type: 'normal'
        },
        {
            prop: 'taskCount',
            label: '单量',
            type: 'normal'
        },
        {
            prop: 'totalQty',
            label: '总数量',
            type: 'normal'
        },
        {
            prop: 'totalGrossWeight',
            label: '总重量(kg)',
            type: 'normal'
        },
        {
            prop: 'totalVolume',
            label: '总方量(m³)',
            type: 'normal'
        },
        {
            prop: 'actualArriveDate',
            label: '到车时间',
            type: 'normal'
        },
        {
            prop: 'arriveTypeText',
            label: '到车方式',
            type: 'normal'
        },
        {
            prop: 'arriveOperateReason',
            label: '到车人工操作原因',
            type: 'normal'
        }
    ],
    tableListsDataItems: [
        {
            prop: 'receiverDetailAddr',
            label: '站点名称',
            type: 'normal'
        },
        {
            prop: 'receiverDetailAddrAll',
            label: '站点地址',
            type: 'normal'
        },
        {
            prop: 'networkAffect',
            label: '站点作用',
            type: 'normal'
        },
        {
            prop: 'taskCount',
            label: '单量',
            type: 'normal'
        },
        {
            prop: 'totalQty',
            label: '总数量',
            type: 'normal'
        },
        {
            prop: 'totalGrossWeight',
            label: '总重量(kg)',
            type: 'normal'
        },
        {
            prop: 'totalVolume',
            label: '总方量(m³)',
            type: 'normal'
        },
        {
            prop: 'arrivalTime',
            label: '抵达时间',
            type: 'normal'
        },
        {
            prop: 'receiverName',
            label: '收货人',
            type: 'normal'
        },
        {
            prop: 'totalPkgQty',
            label: '包件数',
            type: 'normal'
        },
        {
            prop: 'arrivalWayText',
            label: '抵达方式',
            type: 'normal',
            sort: true
        },
        {
            prop: 'arrivalOperateReason',
            label: '抵达人工操作原因',
            type: 'normal'
        }
    ],
    tabItems: [
        {
            prop: 'type',
            label: '操作类型',
            type: 'normal'
        },
        {
            prop: 'content',
            label: '操作内容',
            type: 'normal'
        },
        {
            prop: 'createUserName',
            label: '创建人',
            type: 'normal'
        },
        {
            prop: 'createTime',
            label: '创建时间',
            type: 'normal'
        }
    ]
};
